(function () {
    'use strict';

    angular.module('app.discounts', [
        // Angular modules 
        'ngRoute',

        // Custom modules 
        'treeControl'
        // 3rd Party Modules
        
    ]);
})();